'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _Modal = require('components/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _SongsList = require('components/SongsList/SongsList');

var _SongsList2 = _interopRequireDefault(_SongsList);

var _songs = require('redux/modules/songs');

var songsActions = _interopRequireWildcard(_songs);

var _SongsSelectPopupFooter = require('components/SongsSelectPopup/SongsSelectPopupFooter');

var _SongsSelectPopupFooter2 = _interopRequireDefault(_SongsSelectPopupFooter);

var _songs2 = require('selectors/songs');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./SongsSelectPopup.scss');

var SongsSelectPopup = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    checkedSongs: (0, _songs2.getCheckedSongsArray)(state)
  };
}, (0, _extends3.default)({}, songsActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_PureComponent) {
  (0, _inherits3.default)(SongsSelectPopup, _PureComponent);

  function SongsSelectPopup() {
    (0, _classCallCheck3.default)(this, SongsSelectPopup);
    return (0, _possibleConstructorReturn3.default)(this, (SongsSelectPopup.__proto__ || (0, _getPrototypeOf2.default)(SongsSelectPopup)).apply(this, arguments));
  }

  (0, _createClass3.default)(SongsSelectPopup, [{
    key: 'onHide',
    value: function onHide() {
      var _props = this.props,
          onHide = _props.onHide,
          setSongsFilter = _props.setSongsFilter;

      setTimeout(function () {
        return setSongsFilter({ kw: '' });
      }, 300);
      onHide();
    }
  }, {
    key: 'save',
    value: function save() {
      var _props2 = this.props,
          onSave = _props2.onSave,
          checkedSongs = _props2.checkedSongs;

      onSave(checkedSongs);
      this.onHide();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          t = _props3.t,
          show = _props3.show,
          checkedSongs = _props3.checkedSongs;

      var modalProps = {
        backdrop: true,
        closeByEsc: false,
        title: t('Add Songs'),
        bsSize: 'lg',
        withoutPadding: true
      };

      return _react2.default.createElement(
        _Modal2.default,
        (0, _extends3.default)({}, modalProps, { show: show, onHide: this.onHide }),
        _react2.default.createElement(_SongsList2.default, {
          className: styles.list,
          onSelect: this.onSelect,
          searchable: true,
          autoFocus: true
        }),
        _react2.default.createElement(_SongsSelectPopupFooter2.default, {
          checkedCount: checkedSongs.length,
          onSave: this.save
        })
      );
    }
  }]);
  return SongsSelectPopup;
}(_react.PureComponent), _class3.propTypes = {
  checkedSongs: _propTypes2.default.array,
  onHide: _propTypes2.default.func,
  onSave: _propTypes2.default.func,
  setSongsFilter: _propTypes2.default.func,
  show: _propTypes2.default.bool,
  t: _propTypes2.default.func
}, _class3.defaultProps = {
  checkedSongs: [],
  onHide: _noop3.default,
  onSave: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onHide', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onHide'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'save', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'save'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = SongsSelectPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SongsSelectPopup/SongsSelectPopup.js
// module id = 2102
// module chunks = 1